import { extend } from './extend'
import { json2search } from './json2search'
/**
 * resolveURL
 */
export default function resolveURL(url, searches = {}, options = {}) {
  const { encode = true } = options
  const a = document.createElement('a')
  a.href = url
  const originSearches = a.search.split('?')[1] || ''
  const paramsAry = originSearches.split('&')
  let searchesMap = {}

  for (let i = 0; i < paramsAry.length; i += 1) {
    const item = paramsAry[i]
    const ary = item.split('=')
    // eslint-disable-next-line prefer-destructuring
    searchesMap[ary[0]] = ary[1]
  }
  searchesMap = extend(true, {}, searchesMap, searches)
  let search = json2search(searchesMap, undefined, encode)
  if (search) {
    search = `?${search}`
  }

  return `${a.origin}${a.pathname}${search}${a.hash}`
}
